import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { updateGrid as updateGridMutation } from "@/graphql/mutations";
import { GraphQLError } from "graphql";
import { updateGridInGrids } from "./getGridsState";
import type { Grid } from "@/API";

const client = generateClient();

export const updateGridState = create<State<Grid | null>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const updateGridIsloading = () =>
  updateGridState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const updateGridIsError = (error: GraphQLError[] | undefined) =>
  updateGridState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const updateGridIsSuccess = (queryResult: Grid) =>
  updateGridState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetupdateGridState = () =>
  updateGridState.setState(() => updateGridState.getInitialState());

type updateGridParams = {
  grid: Grid;
  restaurantsId: string[];
};

export const updateGrid = async (params: updateGridParams) => {
  updateGridIsloading();
  const { grid, restaurantsId } = params;

  try {
    const { data } = await client.graphql({
      query: updateGridMutation,
      variables: {
        frequency: grid.frequency,
        emails: grid.emails,
        name: grid.name,
        columns: grid.columns,
        gridId: grid.id,
        restaurantIds: restaurantsId,
      },
    });

    updateGridIsSuccess(data.updateGrid);
    updateGridInGrids(data.updateGrid);
  } catch (e) {
    const graphQl = e as GraphQLResult<Grid>;
    updateGridIsError(graphQl.errors);
  }
};
